import axios from "axios";
import httpManager from "../utils/httpManager";
import { ProductType } from "@/@types/settings/billing";

const mapProductType = (product: string): ProductType => {
  switch (product.toLowerCase()) {
    case "whatsapp":
      return ProductType.WhatsApp;
    case "voice":
      return ProductType.Voice;
    case "slot_renovation":
      return ProductType.Recharge;
    case "slot":
      return ProductType.Slot;
    default:
      throw new Error(`Unknown product type: ${product}`);
  }
};

interface ProcessPayment {
  amount: number;
  purchaseCode: string;
  userData: { email: string };
  tokenData: { bin: string; channel: string; transactionToken: string };
  productType: "whatsapp" | "voice" | "SLOT" | "SLOT_RENOVATION";
  customerPlanConfigToken?: string;
}

type PaymentState =
  | "Authorized"
  | "Not Authorized"
  | "Confirmed"
  | "Not Confirmed"
  | "Verified"
  | "Not Verified"
  | "Voided"
  | "Not Voided"
  | "Reject"
  | "Review";

class PaymentServices {
  async getSessionToken(amount: number, token?: string): Promise<{ sessionKey: string; purchase_code: string }> {
    const ipResponse = await axios.get("https://api.ipify.org?format=json");
    let url = `/billing/payments/session-token/?amount=${amount}&clientIp=${ipResponse.data.ip}`;
    let options = {};
    if (token) {
      url = `/customers/payments/session-token/?amount=${amount}&clientIp=${ipResponse.data.ip}&customer_plan_config_token=${token}`;
      options = { isPublic: true };
    }
    
    const response = await httpManager.get(url, options);

    return response.data;
  }

  async getSessionTokenToRecharge(amount: number, authData: string) {
    const ipResponse = await axios.get("https://api.ipify.org?format=json");
    const response = await httpManager.get(
      `/billing/payments/session-token/?amount=${amount}&clientIp=${ipResponse.data.ip}`,
      { authData }
    );

    return response.data;
  }

  async processPayment(payment: ProcessPayment): Promise<{ state: PaymentState }> {
    let body = {
      customerEmail: payment.userData.email,
      ...payment.tokenData,
      product_type: payment.productType,
      amount: payment.amount,
      purchase_code: payment.purchaseCode,
      purchase_number: payment.purchaseCode,
    };
    let options = {};

    let url = `/billing/payments/process/?amount=${payment.amount}&purchase_code=${payment.purchaseCode}`;
    if (payment.customerPlanConfigToken) {
      url = `/customers/payments/register/`;
      body = { ...body, customer_plan_config_token: payment.customerPlanConfigToken };
      options = { isPublic: true };
    }
    const response = await httpManager.post(
      url,
      body,
      options,
    );

    return response.data;
  }
}

export const paymentServices = new PaymentServices();
